
function initializeHotUpdate() {
	// Manual hot reload for CSS because ExtractTextPlugin doesn't support it.
	// Source: https://github.com/webpack/extract-text-webpack-plugin/issues/30#issuecomment-219852782
	const originalCallback = window.webpackHotUpdate;
	window.webpackHotUpdate = (...args) => {
		// eslint-disable-next-line no-restricted-syntax
		for (const link of document.getElementsByTagName('link')) {
			if (link.href.search('bundle.css') !== -1) {
				const linkHref = link.href;
				link.href = 'about:blank';
				link.href = linkHref;
				originalCallback(...args);
				return;
			}
		}
	};
}

export {
	initializeHotUpdate
};



/** WEBPACK FOOTER **
 ** ./src/app/utils/serverUtils.js
 **/